import { ReactNode, FC } from 'react';

interface ULProps {
  children: ReactNode;
}

export const UL: FC<ULProps> = ({ children }): JSX.Element => (
  <ul className="p-2 bg-green-700 space-y-4">{children}</ul>
);

interface LIProps {
  className?: string;
  children: ReactNode;
}

export const LI: FC<LIProps> = ({ className, children }): JSX.Element => (
  <li className={`p-3 bg-green-600 text-slate-300 ${(className as string) ?? ''}`}>{children}</li>
);
